import { render, staticRenderFns } from "./figure.vue?vue&type=template&id=20277347&scoped=true"
import script from "./figure.vue?vue&type=script&lang=js"
export * from "./figure.vue?vue&type=script&lang=js"
import style0 from "./figure.vue?vue&type=style&index=0&id=20277347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20277347",
  null
  
)

export default component.exports